export default __webpack_public_path__ + "static/teamAug2-d51d6c0eee405ce31004779f651555f2.jpeg";